import { render, staticRenderFns } from "./ClientSuspendedBanner.vue?vue&type=template&id=266612f4&scoped=true"
import script from "./ClientSuspendedBanner.vue?vue&type=script&lang=js"
export * from "./ClientSuspendedBanner.vue?vue&type=script&lang=js"
import style0 from "@/sass/components/_client-suspended-banner.scss?vue&type=style&index=0&id=266612f4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266612f4",
  null
  
)

export default component.exports